<template>
  <el-collapse
    v-model="collapseModel"
    :accordion="true"
  >
    <el-collapse-item
      title="Detalle de productos"
      name="products"
    >
      <div>
        <InputProductosTerminadosItem
          v-for="(producto, index) in productos"
          :key="index"
          :index="index"
          :producto="producto"
          :clientes="clientesEffective"
          :validacionesCantidades="validacionesCantidades"
          :hasQuantityError="hasQuantityError"
          :precision="precision"
          @update-producto="updateProducto"
          @remove-producto="removeProducto"
          @find-producto="findProducto"
        />
      </div>
      <el-row :gutter="24">
        <el-col
          :offset="15"
          :span="4"
          style="padding-right: 4px"
        >
          <div class="button-position">
            <el-button
              class="add-button"
              type="primary"
              size="default"
              :icon="IconAdd"
              @click="addProducto"
              >Agregar producto</el-button
            >
          </div>
        </el-col>
      </el-row>
    </el-collapse-item>
  </el-collapse>

  <InputProductosTerminadosDrawer
    v-if="drawer"
    :visible="drawer"
    :clientes="clientesEffective"
    :codigoElementoGrupo="codigoElementoGrupo"
    :et-recomendada="etDetectada"
    :codigos-ya-seleccionados="codigosExistentes"
    permitir-alta-rapida
    :codigo-unidad-medida-default="codigoUnidadVenta"
    @select-poducto="selectProducto"
    @close-drawer="drawer = false"
  />
</template>

<script setup>
import {
  ref,
  computed,
} from 'vue';

import IconAdd from '~icons/mdi/add';
import InputProductosTerminadosItem from '@/shared/components/input_productos_terminados_item.vue';
import InputProductosTerminadosDrawer from '@/shared/components/input_productos_terminados_drawer.vue';

const collapseModel = ref(['products']);
const drawer = ref(false);
const indexSelected = ref(-1);

const props = defineProps({
  productos: { type: Array, required: true, default: () => [] },
  codigoElementoGrupo: { type: Number },
  codigoCliente: { type: Number },
  codigoUnidadVenta: { type: Number, default: null },
  clientes: { type: Array, default: null },
  validacionesCantidades: { type: Array, default: () => [] },
  hasQuantityError: { type: Boolean, default: false },
  precision: { type: Number, default: 0 },
});

const clientesEffective = computed(() => {
  if (Array.isArray(props.clientes) && props.clientes.length) return props.clientes;
  return props.codigoCliente ? [props.codigoCliente] : [];
});

const emit = defineEmits(['add-producto', 'remove-producto', 'update-producto']);

const addProducto = () => {
  emit('add-producto');
};

const removeProducto = (index) => {
  emit('remove-producto', index);
};

const updateProducto = (data) => {
  emit('update-producto', data);
};

const findProducto = (index) => {
  drawer.value = true;
  indexSelected.value = +index;
};

const etDetectada = computed(() => {
  if (!props.productos || props.productos.length === 0) return null;
  const productoConET = props.productos.find(
    (p) => p.CodigoEspecificacionTecnica || p.CodigoETBase,
  );
  if (!productoConET) return null;

  if (productoConET.CodigoETBase) return productoConET.CodigoETBase;
  if (productoConET.Material?.CodigoBase) return productoConET.Material.CodigoBase;

  return productoConET.CodigoEspecificacionTecnica;
});

const codigosExistentes = computed(() => {
  if (!props.productos) return [];

  return props.productos
    .filter((p) => p.CodigoProducto)
    .map((p) => {
      const codigoPT = p.CodigoProducto;
      const codigoET = p.CodigoEspecificacionTecnica || 'null';

      return `${codigoPT}-${codigoET}`;
    });
});

const selectProducto = (data) => {
  const payload = {
    ...props.productos[indexSelected.value],
    Material: {
      ...data,
      Codigo: data.CodigoProducto ? Number(data.CodigoProducto) : null,
      CodigoEquivalente: data.CodigoEquivalente,
      CodigoAdicional: data.CodigoAdicional,
      CodigoBase: data.CodigoBase,
      DescripcionComercial: data.Descripcion,
    },

    CodigoProducto: data.CodigoProducto ? String(data.CodigoProducto) : null,
    CodigoEspecificacionTecnica: data.CodigoET,
    CodigoETBase: data.CodigoBase || data.CodigoET,
    Descripcion: data.Descripcion,
    AlicuotaIVA: data.AlicuotaIVA,
  };
  emit('update-producto', { producto: payload, index: indexSelected.value });
  drawer.value = false;
};
</script>

<style scoped>
.custom-label {
  font-weight: 700;
  color: #111;
}

.button-position {
  display: flex;
  justify-content: flex-end;
}

.add-button {
  margin-left: auto;
}
</style>
